import { Label, Select } from "@educrib/firefly";
import FieldGroup from "./FieldGroup";

type BooleanProps = {
  name: string;
  placeholder: string;
  label?: boolean;
};

export default function Boolean({
  name,
  placeholder,
  label = true,
}: BooleanProps) {
  return (
    <FieldGroup>
      {label && <Label>{placeholder}</Label>}
      <Select name={name} placeholder={placeholder}>
        <option key="yes" value="yes">
          Yes
        </option>
        <option key="no" value="no">
          No
        </option>
      </Select>
    </FieldGroup>
  );
}
